import React, { useEffect, useRef } from 'react';
import Modal from '../../../../../components-new/ui/Modal';
import PropTypes from 'prop-types';
import config from "../../../../../config";
import { generalModalStyles } from "../../../../../utils/General";

Modal.setAppElement('#root');

const VideoViewer = ({ video, close }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.play().catch(() => {
                });
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [video]);

    return (
        <Modal footer={null}
            closeTimeoutMS={config.closeTimeoutMS}
            isOpen
            style={generalModalStyles.videoViewerModalStyles}
            onRequestClose={close}
        >
            <video
                ref={videoRef}
                className="modal-content videoPopup"
                id="video-source"
                controls
                style={{ width: '100%', maxHeight: '450px' }}
            >
                <source src={video.url} />
            </video>
        </Modal>
    );
};

VideoViewer.propTypes = {
    video: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
};

export default VideoViewer;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/VideoViewer.jsx